import { useEffect } from "react";
import { useSelector } from "react-redux";
import i18n from "../i18n";

const Lang = () => {
    const lang = useSelector((state) => state.lang.language);
    useEffect(() => {
        if (lang !== i18n.language) {
            i18n.changeLanguage(lang)
        }
    }, [lang]);

    return null;
};

export default Lang;
